import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/tools/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/tools/auto-detect', params, replace: true });
    },
});
